import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import { ActionsStyle, CardStyle, TextStyle, TitleStyle } from './styled';

export interface IAutomatedBulletinMessageCompProps {
  messageDateTime?: string,
  message?: string,
  closeHandler?: () => void,
  title?: string,
  priority?: string,
}

export const AutomatedBulletinMessageComp = ({
  messageDateTime = '',
  message = '',
  closeHandler,
  title,
  priority
}: IAutomatedBulletinMessageCompProps) => {
  const navigate = useNavigate();

  const onViewJobs = () => {
    navigate('/work-info/vancouver');
  }

  return (
    <Card className={`${priority}`} sx={CardStyle} variant="outlined">
      <CardContent sx={{ pt: 2, pb: 0 }}>
        <Typography sx={TitleStyle} color="text.secondary" gutterBottom>
          {title}
        </Typography>
        <Typography
          sx={TextStyle}
          variant="body2"
        >
          {message}
        </Typography>
      </CardContent>
      <CardActions sx={ActionsStyle}>
        <Button sx={{ fontWeight: 'bold' }} onClick={onViewJobs} size="small">
          View Jobs
        </Button>
      </CardActions>
    </Card>
  );
}